/* ==========================================================================
   CENCI CALZATURE — Theme JavaScript
   Dipendenze: nessuna, vanilla JS
   ========================================================================== */

(function(){
  'use strict';
  const prefersReduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  const hasTouch = matchMedia('(hover:none)').matches;

  // ============ HEADER SCROLLED ============
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  }

  // ============ ANNOUNCEMENT BAR HEIGHT -> --ann-h ============
  // L'header e' fissato a top:var(--ann-h). Se la barra annuncio (.odometer)
  // non c'e' o cambia altezza (es. mobile), allineo l'header alla sua altezza reale.
  const annBar = document.querySelector('.odometer');
  function setHeaderVars(){
    const a = annBar ? Math.round(annBar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--ann-h', a + 'px');
    // --header-h: altezza reale dell'header, usata per lo scroll-padding (ancore)
    if (header) {
      document.documentElement.style.setProperty('--header-h', Math.round(header.getBoundingClientRect().height) + 'px');
    }
  }
  setHeaderVars();
  window.addEventListener('resize', setHeaderVars, { passive: true });

  // ============ HERO SCENES (auto + dots) ============
  const scenes = document.querySelectorAll('.hero-scenes .scene');
  const dots = document.querySelectorAll('.scene-dots button');
  if (scenes.length) {
    let sceneIdx = 0, sceneTimer;
    function showScene(n){
      scenes.forEach((s, i) => s.classList.toggle('active', i === n));
      dots.forEach((d, i) => d.classList.toggle('active', i === n));
      sceneIdx = n;
    }
    function autoScene(){
      clearInterval(sceneTimer);
      sceneTimer = setInterval(() => {
        showScene((sceneIdx + 1) % scenes.length);
      }, 5000);
    }
    dots.forEach((d, i) => d.addEventListener('click', () => { showScene(i); autoScene(); }));
    autoScene();
  }

  // ============ HERO PARALLAX ============
  if (!prefersReduce) {
    const parallaxEls = document.querySelectorAll('[data-parallax]');
    if (parallaxEls.length) {
      let rafId;
      function updateParallax(){
        parallaxEls.forEach(el => {
          const rect = el.getBoundingClientRect();
          const winH = window.innerHeight;
          if (rect.bottom < 0 || rect.top > winH) return;
          const speed = parseFloat(el.dataset.parallax) || 0.3;
          // Ancorato a rect.top (non a rect.top - winH): per un hero gia' in cima
          // la traslazione a riposo e' ~0, cosi' l'immagine riempie l'hero e non
          // resta una fascia scura scoperta sopra la foto.
          const offset = rect.top * speed;
          el.style.transform = `translate3d(0, ${-offset}px, 0)`;
        });
      }
      function onScroll(){
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateParallax);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateParallax();
    }
  }

  // ============ REVEAL ON SCROLL (generic .reveal and .reveal-up) ============
  if ('IntersectionObserver' in window) {
    const revealIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in', 'in-view');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal, .reveal-up, .gen, .mano-step').forEach(el => revealIO.observe(el));
  }

  // ============ NUMBER COUNTER (on [data-count]) ============
  if ('IntersectionObserver' in window) {
    const countEls = document.querySelectorAll('[data-count]');
    const countIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const raw = (el.dataset.count || '').toString().replace(/[^\d.-]/g,'');
        const target = parseFloat(raw);
        if (isNaN(target)) { countIO.unobserve(el); return; }
        const suffix = (el.dataset.count || '').replace(raw, '').trim();
        const dur = 1600;
        const start = performance.now();
        function step(t){
          const p = Math.min(1, (t - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = Math.round(target * eased);
          el.textContent = val + (suffix ? ' ' + suffix : '');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        countIO.unobserve(el);
      });
    }, { threshold: 0.4 });
    countEls.forEach(el => countIO.observe(el));
  }

  // ============ SIGNATURE DRAW ============
  const sig = document.getElementById('signature');
  if (sig && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          sig.classList.add('in-view');
          io.unobserve(sig);
        }
      });
    }, { threshold: 0.3 });
    io.observe(sig);
  }

  // ============ MAGNETIC BUTTONS (legacy) ============
  if (!hasTouch && !prefersReduce) {
    document.querySelectorAll('.magnetic-btn').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${x * 0.18}px, ${y * 0.25}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  // ============ VALORI FLIP (legacy tap on mobile) ============
  document.querySelectorAll('.valore').forEach(v => {
    v.addEventListener('click', () => {
      if (hasTouch) v.classList.toggle('flipped');
    });
  });
})();
